// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__3CdU6","title":"ClientInsurance_title__3mXbk","itemText":"ClientInsurance_itemText__2t8KE"};